var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.delegations, function(delegation) {
      return _c(
        "v-chip",
        {
          key: delegation.id,
          staticStyle: {
            color: "#FFE3F3",
            "background-color": "#ff99d0 !important"
          },
          style: {
            color: _vm.getColorByStatus(delegation.status),
            "background-color": _vm.getBackgroundColorByStatus(
              delegation.status
            )
          },
          attrs: { label: "", outlined: "", small: "" }
        },
        [_vm._v(_vm._s(_vm.getTextByStatus(delegation.status)) + " ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }